import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  image: {
    width: 500,
    height: 218,
  },
});
